import { useDispatch, useSelector } from 'react-redux'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  PhysiotherapyPrescriptionType,
  PrescriptionViewModel,
} from '../../../models/ViewModels/PrescriptionViewModel'
import { LoadingFit, RaytebModal } from '../../../share/Components'
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  RaytebForm,
  Table,
  TextBox,
  Typeahead,
  TypeaheadText,
} from '../../../share/Elements'
import React, { useEffect, useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import {
  addOrUpdatePrescription,
  updatePhysiotherapyRow,
  updateShouldPush,
} from '../../../storeManager/Reducers/prescriptionSlice'
import { toast } from 'react-toastify'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { GetPriceViewModel } from '../../../models/ViewModels/GetPriceViewModel'
import { PhysiotherapyChosenViewModel } from '../../../models/ViewModels/PhysiotherapyChosenViewModel'
import { PhysiotherapyViewModel } from '../../../models/ViewModels/PhysiotherapyViewModel'
import { ReactElement } from 'react'

type TypeaheadData = {
  show: boolean
  data?: any
}
const Physiotherapy = ({
  physiotherapy,
  prescriptionId,
  isPreview,
  setButtomPage,
}: {
  physiotherapy: PhysiotherapyPrescriptionType
  prescriptionId: string
  isPreview?: boolean
  setButtomPage?: (child: ReactElement | null) => void
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dispatch = useDispatch()
  const [data, setData] = useState<PhysiotherapyServeViewModel>({})

  const getServe = useFetch<
    Array<PhysiotherapyServeViewModel>,
    unknown,
    {
      prescriptionId: string
      filter: string
    }
  >({
    request: RaytebRequests.Physiotherapy_Serves_GET({ token: user.token }),
    onSuccess(data) { },
  })

  const savePhysiotherapy = useFetch<
    PhysiotherapyViewModel,
    PhysiotherapySaveInputModel
  >({
    request: RaytebRequests.Physiotherapy_AddOrUpdate_POST({
      token: user.token,
    }),
    onSuccess(data) {
      dispatch(updatePhysiotherapyRow(data.rows))
      dispatch(updateShouldPush(true))
      setShowModal({ show: false })
      setButtomPage?.(null)
      setData({ ...data, isEdit: false, title: '' })
      data.messages?.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const deletePhysiotherapy = useFetch<
    PrescriptionViewModel,
    unknown,
    {
      id: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Physiotherapy_Remove_DELETE({
      token: user.token,
    }),
    onSuccess(data) {
      data.shouldPush = true
      dispatch(addOrUpdatePrescription(data))
    },
  })
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  })
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
  })
  const buttomElement = (
    <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
      <Button
        onClick={() => {
          setShowModal({ ...showList, show: false })
          setData({ isEdit: false })
          setButtomPage?.(null)
        }}
        className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg  md:!w-56'
      >
        انصراف
      </Button>
      <Button
        onClick={() =>
          document.getElementById('savePhysiotherapySubmit')?.click()
        }
        className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
      >
        تایید
      </Button>
    </div>
  )
  const selectedItem = (item: PhysiotherapyServeViewModel) => {
    setData({ id: item.id, isEdit: false, title: item.title })
    setRowParam({ serveId: item.id })
    setShowModal({ ...showList, show: true })
    setButtomPage?.(buttomElement)
    setTimeout(() => {
      document.getElementById('TotalNumber')?.focus()
    }, 200)
    setshowList({ ...showList, show: false })
    getServe.reFetch(null, {
      prescriptionId: prescriptionId,
      filter: '',
    })
  }
  const fieldPhysiotherapy = 'title'
  const [price, setPrice] = useState<GetPriceViewModel>({})
  const getPrice = useFetch<
    GetPriceViewModel,
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Physiotherapy_GetPrice_GET({ token: user.token }),
    onSuccess(data) {
      data.show = true
      setPrice(data)
    },
  })
  useEffect(() => {
    if (!isPreview)
      getServe.reFetch(null, { prescriptionId: prescriptionId, filter: '' })
  }, [])

  const [rowParam, setRowParam] = useState<PhysiotherapySaveInputModel>({})
  return (
    <div className='py-5 relative'>
      <LoadingFit
        isLoading={
          savePhysiotherapy.isLoading ||
          deletePhysiotherapy.isLoading ||
          getPrice.isLoading
        }
      />
      {!isPreview ? (
        <ProvideTypeahead
          className={` ${data?.isEdit
            ? 'before:absolute before:z-50 before:bg-white/30 before:w-full before:h-full'
            : ''
            }`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item)
              }}
              listData={getServe.result!}
              isLoading={getServe.isLoading}
              onHide={() => setshowList({ show: false })}
            />
          }
        >
          <div className='px-1 flex justify-start items-end md:!w-1/2 md:mx-auto'>
            <Typeahead
              innerText='نام یا کد خدمت فیزیوتراپی'
              className='!w-full'
              onClick={(e) => {
                e.target.select()
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) =>
                getServe.reFetch(null, {
                  prescriptionId: prescriptionId,
                  filter: e.target.value,
                })
              }
              value={data![fieldPhysiotherapy]}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
      ) : (
        ''
      )}
      {showModal.show && !isPreview ? (
        <RaytebForm
          checkIsRequired={true}
          onSubmit={(e) => {
            savePhysiotherapy.reFetch({
              description: e.currentTarget['description'].value,
              effectiveDate:
                e.currentTarget['date'].getAttribute('rayteb-value'),
              prescriptionId: prescriptionId,
              amount: e.currentTarget['count'].value,
              repeatCount: e.currentTarget['Repeat'].value,
              serveId: rowParam.serveId!,
              id: rowParam.id,
              repeatType: rowParam.repeatType,
            })
          }}
        >
          <div className='w-full p-1 grid grid-cols-2 py-3 gap-x-3 gap-y-6'>
            <TextBox
              id='TotalNumber'
              innerText='تعداد'
              Type={TextBoxTypeEnum.Number}
              className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
              isRequired={true}
              name='count'
              value={rowParam.amount?.toString()}
            />
            <DatePicker
              innerText='تاریخ موثر'
              canDeleteDate={true}
              className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
              value={
                rowParam.effectiveDate
                  ? new Date(rowParam.effectiveDate).toShamsi()
                  : ''
              }
              name='date'
              raytebValue={rowParam.effectiveDate}
            />
            <TypeaheadText<{
              value: number
              title: string
            }>
              selected={(e) => {
                setRowParam({ ...rowParam, repeatType: e.value })
              }}
              listData={[
                { title: 'روز', value: 0 },
                { title: 'هفته', value: 1 },
                { title: 'ماه', value: 2 },
              ]}
              fieldItem='title'
              fieldValue='value'
              isReadOnly={false}
              innerText='نوع تکرار نسخه'
              className='!bg-white'
              classNameList='h-20'
            />
            <TextBox
              innerText='دوره تکرار'
              Type={TextBoxTypeEnum.Number}
              value={rowParam.repeatCount?.toString()}
              name='Repeat'
              className='w-full border-0 border-b rounded-none
             focus:!border-0 focus:!border-b focus:!ring-0'
            />
            <div className='col-span-2 mt-3'>
              <TextBox
                innerText='توضیحات دارو فیزیوتراپی'
                Type={TextBoxTypeEnum.Text}
                className='!w-full  h-20'
                name='description'
                value={rowParam.description?.toString()}
              />
            </div>
          </div>
          <input
            type='submit'
            id='savePhysiotherapySubmit'
            className='hidden'
          />
        </RaytebForm>
      ) : (
        <>
          <div className='w-full px-2 mt-6'>
            <Table>
              <thead className='text-xs text-primary h-8 border-b border-disable'>
                <tr>
                  <th scope='col' className='pr-2 text-center font-normal '>
                    کد
                  </th>
                  <th scope='col' className='pt-1 p-0 text-center font-normal'>
                    نام خدمت فیزیوتراپی
                  </th>
                  <th scope='col' className='pt-1 text-center font-normal'>
                    تعداد
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    تاریخ موثر
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody className='text-xs'>
                {physiotherapy.rows?.map((row, i) => (
                  <tr className='[&>*]:h-10' key={i}>
                    <td className='pr-2 text-center'>{row.serveId}</td>
                    <td
                      className='text-center decoration-dotted underline underline-offset-8 cursor-pointer'
                      onClick={() =>
                        getPrice.reFetch(null, {
                          prescriptionId: prescriptionId,
                          rowId: row.id!,
                        })
                      }
                    >
                      {row.title?.shortText(40)}
                    </td>
                    <td className='text-center'>{row.amount}</td>
                    <td className='text-center'>
                      {row.effectiveDate
                        ? new Date(row.effectiveDate).toShamsi()
                        : ''}
                    </td>
                    <td className='grid grid-cols-2 justify-items-center p-1 gap-1'>
                      {!row.isDeleted ? (
                        <>
                          <Icon
                            icon='rayteb-delete'
                            className='text-[17px] text-danger'
                            onClick={() => {
                              deletePhysiotherapy.reFetch(null, {
                                prescriptionId: prescriptionId,
                                id: row.id!,
                              })
                            }}
                            disabled={isPreview}
                          />
                          <Icon
                            icon='rayteb-edit'
                            className='text-[17px] text-warn'
                            onClick={() => {
                              setData({
                                title: row.title!,
                                id: row.id!,
                                isEdit: true,
                              })
                              setRowParam({
                                description: row.description,
                                effectiveDate: row.effectiveDate,
                                id: row.id,
                                amount: row.amount,
                              })
                              setShowModal({ show: true })
                              setButtomPage?.(buttomElement)
                            }}
                            disabled={isPreview}
                          />
                        </>
                      ) : (
                        ''
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}

      <RaytebModal
        isOpen={price.show ?? false}
        hideModal={() => setPrice({ show: false })}
        title='قیمت خدمت'
      >
        <div className='p-2'>
          <Table>
            <thead className='text-xs text-primary h-8 border-b border-disable'>
              <tr>
                <th
                  scope='col'
                  className='pt-1 p-0 text-center font-normal w-10'
                >
                  سهم سازمان
                </th>
                <th scope='col' className='pt-1 p-0 text-center font-normal'>
                  سهم بیمار
                </th>
                <th
                  scope='col'
                  className='pt-1 pl-2 text-center font-normal w-10'
                >
                  کل
                </th>
              </tr>
            </thead>
            <tbody className='text-xs'>
              <tr className={`[&>*]:h-14`}>
                <td className='text-center'>{price.insureShare}</td>
                <td className='text-center'>{price.patientShare}</td>

                <td className='text-center'>{price.total}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-xs w-full flex flex-col gap-3'>
            {price.messages?.map((n) => (
              <span
                className={`${n.flag === ErrorTypeEnum.Error
                  ? 'text-danger'
                  : n.flag === ErrorTypeEnum.Info
                    ? 'text-primaryLight'
                    : n.flag === ErrorTypeEnum.Warning
                      ? 'text-warn'
                      : ''
                  }`}
              >
                {n.message}
              </span>
            ))}
          </div>
        </div>
      </RaytebModal>
    </div>
  )
}

type ListChildrenType = {
  listData?: Array<PhysiotherapyServeViewModel>
  className?: string | undefined
  isLoading: boolean
  onHide?: () => void
  onClick?: (param: PhysiotherapyServeViewModel) => void
}
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          <p className='text-xs mr-2 font-bold text-warn '>
            برای تجویز بر روی یکی از موارد کلیک کنید
          </p>
        </div>

        <div className='h-64 overflow-y-auto'>
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm ${className ?? ''}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className='flex justify-start items-center   py-1  w-full hover:bg-primaryDefault hover:cursor-pointer '
                onClick={() => onClick?.(n)}
              >
                <p className='text-xs font-bold text-end text-primaryLight'>
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
export default React.memo(Physiotherapy)
